
import { Component, Vue } from "vue-property-decorator";
import { Request } from "@/interfaces";
import {
  dispatchGetRequests,
  dispatchConfirmRequest,
  dispatchGetRequestStates,
} from "@/store/main/actions";
import { readOneRequest, readRequestStateName } from "@/store/main/getters";

@Component
export default class SettleRequest extends Vue {
  public valid = true;
  public loading = true;
  public request: Request | null = null;
  public TYPE_TRANSFER = 1;
  public TYPE_WITHDRAW = 2;
  public type = this.TYPE_WITHDRAW;

  public async mounted() {
    this.loading = true;
    await Promise.allSettled([
      dispatchGetRequests(this.$store),
      dispatchGetRequestStates(this.$store),
    ]);
    const request = readOneRequest(this.$store)(
      +this.$router.currentRoute.params.id
    );

    this.loading = false;
  }

  public async cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$validator.validateAll()) {
      await dispatchConfirmRequest(this.$store, {
        id: this.request!.id,
      });
      this.$router.push({
        name: "main-request-view",
      });
    }
  }

  get from_amount() {
    const amount = this.request;

    if (!this.request?.state) return "----";
    return "----";
  }

  get to_amount() {
    return "----";
  }

  get state() {
    const state_id = readOneRequest(this.$store)(
      +this.$router.currentRoute.params.id
    )?.state;
    if (!state_id) return "----";
    return readRequestStateName(this.$store)(state_id);
  }

  public getColor() {
    if (this.state === "COMPLETED" || this.state === "APPLIED")
      return "color:green";
    else if (this.state === "NOT_CREATED" || this.state === "FAILED")
      return "color:red";
    return "color:blue";
  }
}
